// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminResearch from './components/DashboardComponent/AdminResearch';
// Homepage
import Navbar from './components/HomepageComponents/navbar';
import HeroSection from './components/HomepageComponents/hero';
import VmgSection from './components/HomepageComponents/vmg';
import SdgSection from './components/HomepageComponents/sdg';
import FooterSection from './components/HomepageComponents/footer';
import ResearchPage from './pages/ResearchPage';
import About from './components/About/About';
import Projects from './pages/Projects/Projects';

// Admin Components
import AdminDashboard from './components/DashboardComponent/AdminDashboard';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Homepage (public) */}
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <HeroSection />
                <VmgSection />
                <SdgSection />
                <FooterSection />
              </>
            }
          />
          
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          
          {/* Redirect after login → always to /admin */}
          <Route path="/dashboard" element={<DashboardRedirect />} />

          {/* Public full research page */}
          <Route path="/research" element={<ResearchPage />} />

          {/* Admin Dashboard ONLY */}
          <Route path="/admin" element={<AdminDashboard />} />
          
          {/* ROUTE */}
          <Route path="/admin/research" element={<AdminResearch />} />
        </Routes>
      </div>
    </Router>
  );
}

// Simplified redirect — only Admin
const DashboardRedirect = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  return <Navigate to="/admin" replace />;
};
export default App;